import React, { useEffect, useState } from "react";
import "./vertical-timeline.css";
import BuildIcon from "@mui/icons-material/Build";
import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
import ArticleIcon from "@mui/icons-material/Article";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShieldIcon from "@mui/icons-material/Shield";
import FactoryIcon from "@mui/icons-material/Factory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/Category";
import { Science } from "@mui/icons-material";
import Cookies from "universal-cookie";
import { getSubModulesByRoleId } from "store";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const cookies = new Cookies();

const VerticalTimeline = ({
  steps = [],
  onStepClick,
  openStepForProductTests,
  openStepForTechnicalDocuments,
  openStepForDurability,
  openStepForRawMaterial,
  openStepForPWM,
  openStepForEvt,
  openStepForCOC,
  openStepForManufacturing,
  openStepForRCV,
  mainData,
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,
}) => {

  // let jwtToken = loginDetails?.jwt;

  // let roleId = loginDetails?.data?.roleId;
  // useEffect(() => {
  //   getSubModulesByRoleId(roleId, jwtToken);
  // }, [roleId]);

  // const [modulesData, setModulesData] = useState([]);

  // useEffect(() => {
  //   setModulesData(
  //     getSubModulesByRoleIdReducer.subModulesByRoleData.data
  //       ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
  //       : [],
  //   );
  // }, [getSubModulesByRoleIdReducer]);

  // let packagingModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "7e02c688-4e21-4805-9f51-2320dda92382",
  // );

  // let viewPackaging = packagingModule
  //   ? packagingModule.actionId.includes("825e65a6-0f01-4fe7-91a1-63cb571b093a")
  //   : null;

  // let productTestingModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  // );

  // let viewProductTesting = productTestingModule
  //   ? productTestingModule.actionId.includes(
  //       "896c7b19-7fe5-4306-9f06-2735e57a7b84",
  //     )
  //   : null;

  // let durabilityModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "5e690abe-d7a1-4e45-8782-43409b4edab2",
  // );

  // let viewDurability = durabilityModule
  //   ? durabilityModule.actionId.includes("24059d11-ee70-4a0d-a132-56bf7195de49")
  //   : null;

  // let cocModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "269b317f-3fc3-4ce8-b885-0817acf36a66",
  // );

  // let viewCoc = cocModule
  //   ? cocModule.actionId.includes("1f130e9a-11bf-4ad3-b690-4fcefedfbb44")
  //   : null;

  // let rmModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "852fd581-2cd9-40d1-b0f6-e29dd61566ff",
  // );

  // let viewRm = rmModule
  //   ? rmModule.actionId.includes("94e1aedf-8637-4d27-9079-2812f320e458")
  //   : null;

  // let repairValueModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "9f3b7cf0-eb97-4567-8d4a-711868269662",
  // );

  // let viewRepairValue = repairValueModule
  //   ? repairValueModule.actionId.includes(
  //       "a0f6b96e-282c-4349-b655-f08f172739f8",
  //     )
  //   : null;

  // let manufacturingModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
  // );

  // let viewManufacturing = manufacturingModule
  //   ? manufacturingModule.actionId.includes(
  //       "6fd9218e-53e3-49ec-85bc-ef986f9ede86",
  //     )
  //   : null;

  // let validationModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
  // );

  // let viewValidation = validationModule
  //   ? validationModule.actionId.includes("acf6e194-8a3f-4c7f-98b7-9cc2151ed763")
  //   : null;

  // let socialComplianceModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "013a3276-d1db-4051-b489-b199b4710cf4",
  // );

  // let viewSocialCompliance = socialComplianceModule
  //   ? socialComplianceModule.actionId.includes(
  //       "3dce3a16-274c-4937-92cc-df13fa7c6c8d",
  //     )
  //   : null;

  const { pathname, search } = useLocation();
  const queryParams = new URLSearchParams(search); 
  const hasDppId = queryParams.get("dppId") || queryParams.get("dppid");
  // const isIndustry1 = queryParams.get("industryId") === "1" || queryParams.get("industryid") === "1";
 
  const isFromQRCode = (pathname.toLowerCase() === "/dpp") && hasDppId ;

  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails?.data?.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);


  let packagingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "7e02c688-4e21-4805-9f51-2320dda92382",
  );
  let viewPackaging = isFromQRCode
    ? true
    : packagingModule
      ? packagingModule.actionId.includes("825e65a6-0f01-4fe7-91a1-63cb571b093a")
      : null;

  let productTestingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  );
  let viewProductTesting = isFromQRCode
    ? true
    : productTestingModule
      ? productTestingModule.actionId.includes("896c7b19-7fe5-4306-9f06-2735e57a7b84")
      : null;

  let durabilityModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "5e690abe-d7a1-4e45-8782-43409b4edab2",
  );
  let viewDurability = isFromQRCode
    ? true
    : durabilityModule
      ? durabilityModule.actionId.includes("24059d11-ee70-4a0d-a132-56bf7195de49")
      : null;

  let cocModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "269b317f-3fc3-4ce8-b885-0817acf36a66",
  );
  let viewCoc = isFromQRCode
    ? true
    : cocModule
      ? cocModule.actionId.includes("1f130e9a-11bf-4ad3-b690-4fcefedfbb44")
      : null;

  let rmModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "852fd581-2cd9-40d1-b0f6-e29dd61566ff",
  );
  let viewRm = isFromQRCode
    ? true
    : rmModule
      ? rmModule.actionId.includes("94e1aedf-8637-4d27-9079-2812f320e458")
      : null;

  let repairValueModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "9f3b7cf0-eb97-4567-8d4a-711868269662",
  );
  let viewRepairValue = isFromQRCode
    ? true
    : repairValueModule
      ? repairValueModule.actionId.includes("a0f6b96e-282c-4349-b655-f08f172739f8")
      : null;

  let manufacturingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
  );
  let viewManufacturing = isFromQRCode
    ? true
    : manufacturingModule
      ? manufacturingModule.actionId.includes("6fd9218e-53e3-49ec-85bc-ef986f9ede86")
      : null;

  let validationModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
  );
  let viewValidation = isFromQRCode
    ? true
    : validationModule
      ? validationModule.actionId.includes("acf6e194-8a3f-4c7f-98b7-9cc2151ed763")
      : null;

  let socialComplianceModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "013a3276-d1db-4051-b489-b199b4710cf4",
  );
  let viewSocialCompliance = isFromQRCode
    ? true
    : socialComplianceModule
      ? socialComplianceModule.actionId.includes("3dce3a16-274c-4937-92cc-df13fa7c6c8d")
      : null;



  return (
    <div
      className="vtl"
      style={{
        justifyContent: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "80%",
      }}
    >
      <div className="vtl-rail" aria-hidden="true" />

      {/* <div className="vtl-header">
        <h3>Product Lifecycle Journey</h3>
        <small>{`${steps.length} of ${steps.length} stages`}</small>
      </div> */}

      <div className="vtl-list" role="list">
        {viewManufacturing && (
          <>
            {!mainData?.productLifecycleJourney?.manufacturer.orderNumber ||
              mainData?.productLifecycleJourney?.manufacturer.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.manufacturer.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={6}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <Inventory2Icon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.manufacturer?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.manufacturer
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.manufacturer
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.manufacturer.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.manufacturer.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.manufacturer.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.manufacturer.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={6}
                onClick={() => openStepForManufacturing()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "#FF5F15",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <Inventory2Icon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.manufacturer
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.manufacturer?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.manufacturer
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.manufacturer
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.manufacturer.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.manufacturer.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.manufacturer.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.manufacturer.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.manufacturer.status}
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewRm && (
          <>
            {!mainData?.productLifecycleJourney?.rmTraceability.orderNumber ||
              mainData?.productLifecycleJourney?.rmTraceability.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.rmTraceability.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={5}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <CategoryIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.rmTraceability?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.rmTraceability
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.rmTraceability
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.rmTraceability.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.rmTraceability.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.rmTraceability.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.rmTraceability.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={5}
                onClick={() => openStepForRawMaterial()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "#0000FF",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <CategoryIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.rmTraceability
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.rmTraceability?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.rmTraceability
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.rmTraceability
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.rmTraceability.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.rmTraceability.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.rmTraceability.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.rmTraceability.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.rmTraceability.status}
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewProductTesting && (
          <>
            {!mainData?.productLifecycleJourney?.productTests.orderNumber ||
              mainData?.productLifecycleJourney?.productTests.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.productTests.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={0}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <ArticleIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.productTests?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.productTests
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.productTests
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.productTests.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.productTests.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.productTests.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.productTests.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={0}
                onClick={() => openStepForProductTests()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "black",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <Science color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.productTests
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.productTests?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.productTests
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.productTests
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.productTests.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.productTests.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.productTests.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.productTests.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.productTests.status}
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewValidation && (
          <>
            {!mainData?.productLifecycleJourney?.technicalDocuments
              .orderNumber ||
              mainData?.productLifecycleJourney?.technicalDocuments.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.technicalDocuments.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={0}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <ArticleIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.technicalDocuments
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.technicalDocuments
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.technicalDocuments.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.technicalDocuments.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.technicalDocuments
                    .desc && (
                      <p className="vtl-card-desc">
                        {
                          mainData?.productLifecycleJourney?.technicalDocuments
                            .desc
                        }
                      </p>
                    )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={0}
                onClick={() => openStepForTechnicalDocuments()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "#F59E0B",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <ArticleIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.technicalDocuments
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.technicalDocuments
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.technicalDocuments.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.technicalDocuments.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.technicalDocuments
                    .desc && (
                      <p className="vtl-card-desc">
                        {
                          mainData?.productLifecycleJourney?.technicalDocuments
                            .desc
                        }
                      </p>
                    )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          .status
                      }
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewCoc && (
          <>
            {!mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ||
              mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={1}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <LocalShippingIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.chainOfCustody?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.chainOfCustody
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.chainOfCustody
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.chainOfCustody.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.chainOfCustody.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.chainOfCustody.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.chainOfCustody.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={1}
                onClick={() => openStepForCOC()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              // background: s.badgeColor,
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <LocalShippingIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.chainOfCustody
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {mainData?.productLifecycleJourney?.chainOfCustody?.name}
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.chainOfCustody
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.chainOfCustody
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.chainOfCustody.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.chainOfCustody.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.chainOfCustody.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.chainOfCustody.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.chainOfCustody.status}
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewDurability && (
          <>
            {!mainData?.productLifecycleJourney?.durabilityAndLifespan
              .orderNumber ||
              mainData?.productLifecycleJourney?.durabilityAndLifespan
                .orderNumber == "n/a" ||
              mainData?.productLifecycleJourney?.durabilityAndLifespan
                .orderNumber == "" ? (
              <div className="vtl-row" role="button" tabIndex={2}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <ShieldIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.durabilityAndLifespan
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.durabilityAndLifespan
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.durabilityAndLifespan.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.durabilityAndLifespan.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.durabilityAndLifespan
                    .desc && (
                      <p className="vtl-card-desc">
                        {
                          mainData?.productLifecycleJourney?.durabilityAndLifespan
                            .desc
                        }
                      </p>
                    )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={2}
                onClick={() => openStepForDurability()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "#A78BFA",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <ShieldIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.durabilityAndLifespan
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.durabilityAndLifespan
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.durabilityAndLifespan.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.durabilityAndLifespan.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.durabilityAndLifespan
                    .desc && (
                      <p className="vtl-card-desc">
                        {
                          mainData?.productLifecycleJourney?.durabilityAndLifespan
                            .desc
                        }
                      </p>
                    )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          .status
                      }
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewRepairValue && (
          <>
            {!mainData?.productLifecycleJourney?.returnRepairInfo.orderNumber ||
              mainData?.productLifecycleJourney?.returnRepairInfo.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.returnRepairInfo.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={3}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <BuildIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.returnRepairInfo
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.returnRepairInfo
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.returnRepairInfo
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.returnRepairInfo.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.returnRepairInfo.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.returnRepairInfo.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.returnRepairInfo.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={3}
                onClick={() => openStepForRCV()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "#60A5FA",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <BuildIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.returnRepairInfo
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.returnRepairInfo
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.returnRepairInfo
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.returnRepairInfo
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.returnRepairInfo.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.returnRepairInfo.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.returnRepairInfo.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.returnRepairInfo.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.returnRepairInfo
                          .status
                      }
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewPackaging && (
          <>
            {!mainData?.productLifecycleJourney?.packagingWasteManagement
              .orderNumber ||
              mainData?.productLifecycleJourney?.packagingWasteManagement
                .orderNumber == "n/a" ||
              mainData?.productLifecycleJourney?.packagingWasteManagement
                .orderNumber == "" ? (
              <div className="vtl-row" role="button" tabIndex={4}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <FactoryIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card ">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.packagingWasteManagement
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.packagingWasteManagement
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.packagingWasteManagement.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.packagingWasteManagement.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.packagingWasteManagement
                    .desc && (
                      <p className="vtl-card-desc">
                        {
                          mainData?.productLifecycleJourney
                            ?.packagingWasteManagement.desc
                        }
                      </p>
                    )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={4}
                onClick={() => openStepForPWM()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              background: "#FF69B4",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <FactoryIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.packagingWasteManagement
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.packagingWasteManagement
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.packagingWasteManagement.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.packagingWasteManagement.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.packagingWasteManagement
                    .desc && (
                      <p className="vtl-card-desc">
                        {
                          mainData?.productLifecycleJourney
                            ?.packagingWasteManagement.desc
                        }
                      </p>
                    )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement.status
                      }
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}

        {viewSocialCompliance && (
          <>
            {!mainData?.productLifecycleJourney?.socialCompliance.orderNumber ||
              mainData?.productLifecycleJourney?.socialCompliance.orderNumber ==
              "n/a" ||
              mainData?.productLifecycleJourney?.socialCompliance.orderNumber ==
              "" ? (
              <div className="vtl-row" role="button" tabIndex={7}>
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle "
                            style={{
                              background: "grey",
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <EnergySavingsLeafIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card ">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.socialCompliance
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.socialCompliance
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.socialCompliance
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.socialCompliance.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.socialCompliance.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.socialCompliance.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.socialCompliance.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            ) : (
              <div
                className="vtl-row"
                role="button"
                tabIndex={7}
                onClick={() => openStepForEvt()}
              >
                <div className="vtl-node-wrap">
                  <div className="vtl-node">
                    <div className="vtl-node-inner">
                      <div className="vtl-node-icon">
                        <div
                          className="icon-wrap"
                          style={{ marginBottom: "10px" }}
                        >
                          <div
                            className="icon-circle timeline-icon"
                            style={{
                              // background: s.badgeColor,
                              width: "60px",
                              height: "60px",
                            }}
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#fff"
                              strokeWidth="1.6"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <EnergySavingsLeafIcon color="white" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="vtl-step">
                      {
                        mainData?.productLifecycleJourney?.socialCompliance
                          ?.orderNumber
                      }
                    </span>
                  </div>
                  <div className="vtl-connector" />
                </div>

                <div className="vtl-card timeline-icon3">
                  <div className="vtl-card-head">
                    <div className="vtl-card-title">
                      {
                        mainData?.productLifecycleJourney?.socialCompliance
                          ?.name
                      }
                    </div>
                    {/* {
                mainData?.productLifecycleJourney?.socialCompliance
                  .orderNumber
              } */}
                    {/* {mainData?.productLifecycleJourney?.socialCompliance
                ?.status && (
                <span
                  className={`vtl-status vtl-status--${mainData?.productLifecycleJourney?.socialCompliance.status.toLowerCase()}`}
                >
                  {mainData?.productLifecycleJourney?.socialCompliance.status}
                </span>
              )} */}
                  </div>
                  {mainData?.productLifecycleJourney?.socialCompliance.desc && (
                    <p className="vtl-card-desc">
                      {mainData?.productLifecycleJourney?.socialCompliance.desc}
                    </p>
                  )}
                  {/* {!s.tags?.length && ( */}
                  <div className="vtl-card-tags">
                    {/* {s?.tags?.map((t, i) => ( */}
                    <span
                      // key={i}
                      className="vtl-tag"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.socialCompliance
                          .status
                      }
                    </span>
                    {/* ))} */}
                  </div>
                  {/* )} */}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VerticalTimeline);
